import classNames from 'classnames';
import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  secondary?: boolean;
  className?: string;
}

export default function Button({
  children,
  secondary,
  className,
  ...props
}: ButtonProps) {
  return (
    <button
      className={classNames(
        'px-6 py-2 rounded-lg font-waldenburg text-sm transition-all',
        secondary
          ? 'bg-cultured-white hover:bg-blue-jeans-50'
          : 'bg-blue-jeans-500 text-cultured-white hover:bg-blue-jeans-400',
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
